export const localStorageConstants = {
    theme: {
        compactModeEnabled: "theme.compact_mode_enabled",
        darkModeEnabled: "theme.dark_mode_enabled",
    },
};
